
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { TokenPrintModel } from './token-print.model';

export class TokenPrintResponse extends GlobalResponseObject {
    data?: TokenPrintModel;
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: TokenPrintModel) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
